"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ListingApprovalStatus_1 = require("../ListingApprovalStatus");
var state = { listingId: 1, listingBookmarkId: 1 };
var nextListingId = function () {
    var r = state.listingId;
    state.listingId++;
    return r;
};
var nextListingBookmarkid = function () {
    var r = state.listingBookmarkId;
    state.listingBookmarkId++;
    return r;
};
var listingNotFound = function (listingId) {
    return Promise.reject({ code: "NOT_FOUND", message: "Unable to find listing by id: " + listingId });
};
var MockListingService = /** @class */ (function () {
    function MockListingService() {
        this._listings = [
            {
                id: nextListingId(),
                unique_name: "kurtvonnegut",
                title: "Kurt Vonnegut",
                description: "Kurt Vonnegut",
                description_short: "Kurt Vonnegut",
                launch_url: "https://en.wikipedia.org/wiki/Kurt_Vonnegut",
                security_marking: "user",
                approval_status: ListingApprovalStatus_1.ListingApprovalStatus.APPROVED,
                is_enabled: true
            },
            {
                id: nextListingId(),
                unique_name: "johnsteinbeck",
                title: "John Steinbeck",
                description: "John Steinbeck",
                description_short: "John Steinbeck",
                launch_url: "https://en.wikipedia.org/wiki/John_Steinbeck",
                security_marking: "user",
                approval_status: ListingApprovalStatus_1.ListingApprovalStatus.APPROVED,
                is_enabled: true
            },
            {
                id: nextListingId(),
                unique_name: "aldoushuxley",
                title: "Aldous Huxley",
                description: "Aldous Huxley",
                description_short: "Aldous Huxley",
                launch_url: "https://en.wikipedia.org/wiki/Aldous_Huxley",
                security_marking: "user",
                approval_status: ListingApprovalStatus_1.ListingApprovalStatus.APPROVED,
                is_enabled: true
            },
            {
                id: nextListingId(),
                unique_name: "georgeorwell",
                title: "George Orwell",
                description: "George Orwell",
                description_short: "George Orwell",
                launch_url: "https://en.wikipedia.org/wiki/George_Orwell",
                security_marking: "user",
                approval_status: ListingApprovalStatus_1.ListingApprovalStatus.APPROVED,
                is_enabled: true
            },
            {
                id: nextListingId(),
                unique_name: "mcdonalds",
                title: "McDonald's",
                description: "McDonald's",
                description_short: "McDonald's",
                launch_url: "https://en.wikipedia.org/wiki/McDonald%27s",
                security_marking: "user",
                approval_status: ListingApprovalStatus_1.ListingApprovalStatus.IN_PROGRESS,
                is_enabled: true
            },
            {
                id: nextListingId(),
                unique_name: "chocolate",
                title: "Chocolate",
                description: "Chocolate",
                description_short: "Chocolate",
                launch_url: "https://en.wikipedia.org/wiki/Chocolate",
                security_marking: "user",
                approval_status: ListingApprovalStatus_1.ListingApprovalStatus.PENDING,
                is_enabled: true
            }
        ];
        this._bookmarks = [];
    }
    MockListingService.prototype.getListing = function (request) {
        var r = this._listings.find(function (l) { return String(l.id) === String(request.listingId); });
        return r ? Promise.resolve(Object.assign({}, r)) : listingNotFound(request.listingId);
    };
    MockListingService.prototype.saveListing = function (request) {
        if (request.id) {
            var idx = this._listings.findIndex(function (l) { return l.id === request.id; });
            if (idx >= 0) {
                this._listings[idx] = Object.assign({}, this._listings[idx], request);
                return Promise.resolve(Object.assign({}, this._listings[idx]));
            }
            return listingNotFound(request.id);
        }
        var newListing = Object.assign({}, request, { id: nextListingId(), unique_name: request.title });
        this._listings.push(newListing);
        return Promise.resolve(Object.assign({}, newListing));
    };
    MockListingService.prototype.deleteListing = function (request) {
        if (request.id) {
            var idx = this._listings.findIndex(function (l) { return l.id === request.id; });
            if (idx >= 0) {
                this._listings.splice(idx, 1);
                return Promise.resolve();
            }
            return listingNotFound(request.id);
        }
        return Promise.reject({ code: "INVALID_ARGUMENT", key: "id", message: "Listing id not provided" });
    };
    MockListingService.prototype.getListings = function (request) {
        return Promise.resolve({
            listings: this._listings.map(function (listing) { return Object.assign({}, listing); }),
            counts: {
                total: this._listings.length,
                enabled: this._listings.filter(function (l) { return l.is_enabled; }).length
            }
        });
    };
    MockListingService.prototype.searchListings = function (request) {
        return Promise.resolve(null);
    };
    MockListingService.prototype.getBookmarkedListings = function () {
        var _this = this;
        var bookmarks = this._bookmarks.map(function (b) {
            return {
                id: b.id,
                listing: Object.assign({}, _this._listings.find(function (l) { return l.id === b.listing.id; }))
            };
        });
        return Promise.resolve(bookmarks);
    };
    MockListingService.prototype.addBookmark = function (request) {
        var listing = this._listings.find(function (l) { return request.listing && request.listing.id === l.id; });
        if (listing) {
            var r = { id: nextListingBookmarkid(), listing: Object.assign({}, listing) };
            this._bookmarks.push(r);
            return Promise.resolve(Object.assign({}, r));
        }
        return listingNotFound(request.listing ? request.listing.id : undefined);
    };
    MockListingService.prototype.removeBookmark = function (request) {
        var idx = this._bookmarks.findIndex(function (b) { return request.listing && request.listing.id === b.listing.id; });
        if (idx >= 0) {
            var r = this._bookmarks[idx];
            this._bookmarks.splice(idx, 1);
            return Promise.resolve(Object.assign({}, r));
        }
        return Promise.reject({ code: "NOT_FOUND", message: "Bookmark not found" });
    };
    MockListingService.prototype.getStoreFront = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                var r = _this._listings.map(function (l) { return Object.assign({}, l); });
                resolve({
                    featured: r,
                    most_popular: r,
                    recent: r,
                    recommended: r
                });
            }, 1000);
        });
    };
    MockListingService.prototype.getListingReviews = function (request) {
        return Promise.resolve(null);
    };
    MockListingService.prototype.getListingReview = function (request) {
        return Promise.resolve(null);
    };
    MockListingService.prototype.deleteListingReview = function (request) {
        return Promise.resolve(null);
    };
    MockListingService.prototype.saveListingReview = function (review) {
        return Promise.resolve(null);
    };
    MockListingService.prototype.getListingFeedback = function (request) {
        return Promise.resolve(null);
    };
    MockListingService.prototype.getListingActivity = function (request) {
        return Promise.resolve(null);
    };
    return MockListingService;
}());
exports.MockListingService = MockListingService;
